import { render, staticRenderFns } from "./MdmProfileAppPolicyTab.vue?vue&type=template&id=86c77e96&lang=pug&"
import script from "./MdmProfileAppPolicyTab.vue?vue&type=script&lang=js&"
export * from "./MdmProfileAppPolicyTab.vue?vue&type=script&lang=js&"
import style0 from "./MdmProfileAppPolicyTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports